import { useEffect, useState } from "react";

/**
 * Useful for preventing server-client mismatch errors for components that use browser APIs.
 */
export function useIsClient() {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);
  return isClient;
}
